import { CopyToClipboard, Link, SpaceBetween } from '@cloudscape-design/components';
import { useNavigate } from 'react-router';
import { DryRunBadge } from './DryRunBadge';

interface EvaluationIdCellProps {
  evaluationId: string;
  /** When set, the link opens this rule's results pane on the evaluation page (RuleResultsPanel). */
  ruleId?: string;
  /** The rule ran as a dry run in this evaluation, so its results did not count. */
  isDryRun?: boolean;
}

/** A table cell for an evaluation ID: a short link to its detail page, plus a copy button. */
export function EvaluationIdCell({ evaluationId, ruleId, isDryRun }: EvaluationIdCellProps) {
  const navigate = useNavigate();
  // A dry-run result is only returned when asked for, so its link asks for it.
  const params = new URLSearchParams({
    ...(isDryRun ? { includeDryRunResults: 'true' } : {}),
    ...(ruleId ? { rule: ruleId } : {}),
  });
  const href = `/evaluations/${evaluationId}${params.size ? `?${params}` : ''}`;

  return (
    <SpaceBetween direction="horizontal" size="xxs" alignItems="center">
      <Link
        href={href}
        onFollow={(event) => {
          event.preventDefault();
          navigate(href);
        }}
        fontSize="body-s"
      >
        {evaluationId.substring(0, 8)}
      </Link>
      <CopyToClipboard
        variant="icon"
        textToCopy={evaluationId}
        copySuccessText="Evaluation ID copied"
        copyErrorText="Failed to copy"
        copyButtonAriaLabel={`Copy evaluation ID ${evaluationId}`}
      />
      {isDryRun && <DryRunBadge />}
    </SpaceBetween>
  );
}
